<template>
  <div id="header-tab-menu">
    <ol>
      <li v-for="(item, index) in items" :key=index
      v-on:click="onClick(item.path)"
      > {{ item.title }} </li>
    </ol>
  </div>
</template>

<script>

export default {
  name: 'RadiusButton',
  data () {
    return {
      title: 'this will head',
      items: [
        { title: 'churabou', path: '' },
        { title: 'profile', path: 'profile' },
        { title: 'appeal', path: 'appeal' },
        // { title: 'skills', path: 'skills' },
        { title: 'outputs', path: 'outputs' }
      ]
    }
  },

  methods: {
    onClick: function(path) {
      window.location.href = `#/${path}`
    }
  }
}

</script>

<style>

#header-tab-menu {
  /* background-color: #eee; */
}

#header-tab-menu ol {
  text-align: right;
}

#header-tab-menu ol li {
  width: 100px;
  height: 50px;
  background-color: #fff;
  color: darkgray;
  display: inline-block;
  text-align: center;
  line-height: 50px;
  margin-right: 10px;
}

#header-tab-menu ol li:hover {
  opacity: 0.3;
}

</style>



// WEBPACK FOOTER //
// src/components/TabMenu.vue